import React, {Fragment} from 'react';
import {Form, Input} from 'semantic-ui-react';

const CustomerForm = ({customer, handleTextChanged, autoFocus = false}) => {
  return (
    <Fragment>
      <Form.Field
        id="form-create-customer-name"
        name="name"
        value={customer.name}
        onChange={handleTextChanged}
        control={Input}
        label="Name"
        placeholder="Name"
        autoFocus={autoFocus}
      />
      <Form.Field
        id="form-create-customer-epicorId"
        name="epicorId"
        value={customer.epicorId}
        onChange={handleTextChanged}
        control={Input}
        label="Epicor Customer Number"
        placeholder="Epicor Customer Number"
      />
    </Fragment>
  );
};

export default CustomerForm;
